<div class="wrapper__headerComponent container my-1">
  <div class="row align-items-center">
    <div class="col-12 col-xl-12">
      <h2 class="text-center h3-tipografia-govco mb-0">
        {{"password.restablecer_password" | translate}}
      </h2>
    </div>
  </div>
</div>
<div class="wrapper__contentComponent--cuenta container my-5">
  <div class="row align-items-center">
    <div class="col-2"></div>
    <div class="col-8">
      <app-form
        [fields]="restablecerContrasenaForm"
        [withSubmitButton]="true"
        [sumbitButtonText]="this.alertaText['restablecer_password']"
        (submitAction)="onSubmitRestablecerContrasenia($event)">
      </app-form>
    </div>
    <div class="col-2"></div>
  </div>
</div>
